import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const loginFromState = atom({
  key: "loginFromState",
  default: null,
  effects_UNSTABLE: [ocPersistAtom],
});
